// src/services/itemDeliveryService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// const getAllotedItems = async () => {
//   return await axios.get(`${API_URL}/item_inward`);
// };

const getAllotedItems = async () => {
  return await axios.get(`${API_URL}/item_inward/details`);
};

const getAllotedItem = async (id) => {
  return await axios.get(`${API_URL}/item_inward/${id}`);
};

const uplodaBulkAllotedItem = async (data) => {
  return await axios.post(
    `${API_URL}/products/upload-item-delivery`,
    data
  );
};

const downloadBulkAllotedItemFile = async (id) => {
  return await axios.get(
    `${API_URL}/products/download-department-products/${id}`
  );
};

const createAllotedItem = async (itemDeliveryData) => {
  return await axios.post(`${API_URL}/item_inward/`, itemDeliveryData);
};

const updateAllotedItem = async (id, itemDeliveryData) => {
  return await axios.put(`${API_URL}/item_inward/${id}`, itemDeliveryData);
};

const deleteAllotedItem = async (id) => {
  return await axios.delete(`${API_URL}/item_inward/${id}`);
};

export default {
  getAllotedItems,
  getAllotedItem,
  createAllotedItem,
  updateAllotedItem,
  deleteAllotedItem,
  downloadBulkAllotedItemFile,
  uplodaBulkAllotedItem,
};
